import useFetch from './use-fetch'
import * as requests from './requests'

export default useFetch
export { requests }
